import { useState } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Button } from "@atoms"

import { Popover } from "@molecules"
import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"

import TimelineViewMenuBottomSheet from "./TimelineViewMenuBottomSheet/TimelineViewMenuBottomSheet"
import TimelineViewMenuPopover from "./TimelineViewMenuPopover/TimelineViewMenuPopover"
import TimelineViewTimeFrameSelector from "./TimelineViewTimeFrameSelector/TimelineViewTimeFrameSelector"

export default function TimelineViewMenu() {
    const [isTimelineViewMenuOpen, setIsTimelineViewMenuOpen] = useState<boolean>(false)

    const isDesktop = useIsDesktop()

    return (
        <>
            <Popover.Root isOpen={isTimelineViewMenuOpen} onOpenChange={setIsTimelineViewMenuOpen}>
                <Popover.Trigger>
                    <Button
                        size={isDesktop ? "md" : "lg"}
                        variant="subtle"
                        isPressed={isTimelineViewMenuOpen}
                        leftIcon={faIcon({ name: "sliders", style: "regular" })}
                        noDebounce={true}
                    >
                        View
                    </Button>
                </Popover.Trigger>
                {isDesktop ? (
                    <Popover.Viewport>
                        <TimelineViewMenuPopover />
                    </Popover.Viewport>
                ) : (
                    <Popover.Viewport>
                        <ComponentNavigation.Component componentId="main">
                            <TimelineViewMenuBottomSheet />
                        </ComponentNavigation.Component>

                        <ComponentNavigation.Component componentId="time-frame">
                            <ComponentNavigation.Content animationType="fade">
                                <PopoverHeader.Root>
                                    <PopoverHeader.BackButton backDestination="main" aria-label="Back" />
                                    <PopoverHeader.Title title="Time Frame" />
                                </PopoverHeader.Root>
                            </ComponentNavigation.Content>
                            <ComponentNavigation.Content animationType="slide">
                                <TimelineViewTimeFrameSelector.BottomSheet />
                            </ComponentNavigation.Content>
                        </ComponentNavigation.Component>
                    </Popover.Viewport>
                )}
            </Popover.Root>
        </>
    )
}
